import React, {useState} from 'react';
import {NotificacionPushAppComponent} from './NotificacionPushAppComponent';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export const MiNotificacion = (props) => {
	const {nombreUsu, imagenUsu, mensaje, hora} = props;

	const [NotificacionPushApp, setNotificacionPushApp] = useState(false);

	const openNotification = () => {
		setNotificacionPushApp(true);
	};

	const closeNotificacion = () => {
		setNotificacionPushApp(false);
	};

	return (
		<>
			<Modal
				centered={true}
				isOpen={NotificacionPushApp}
				toggle={() => setNotificacionPushApp(!NotificacionPushApp)}
			>
				<ModalHeader>
					<b>Notificación de {nombreUsu}</b>
				</ModalHeader>
				<ModalBody>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
						tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
						quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
						consequat. Duis aute irure dolor in
					</p>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-notificaciones__button'>
						<div
							className='button'
							onClick={() => {
								setNotificacionPushApp(false);
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<div
				className='miNotificacion'
				onClick={openNotification}
			>
				<div className='imagenNotificacion centrador'>
					<img src={imagenUsu} />
				</div>
				<div className='nombreDescripcionNotificacion'>
					<div className='nombreNotificacion'>{nombreUsu}</div>
					<div className='descripcionNotificacion'>{mensaje}</div>
				</div>
				<div className='horaNotificacion centrador'>{hora}</div>
			</div>
		</>
	);
};
